import * as Types from '../../types/generated';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PublicProfileViewQueryVariables = Types.Exact<{
  input: Types.PublicProfileViewInput;
  locale: Types.Scalars['Locale']['input'];
}>;

export type PublicProfileViewQuery = {
  publicProfileView?:
    | {
        __typename: 'RestrictedPublicProfileView';
        slug: string;
        firstName: string;
        lastName: string;
        hasVerifiedCredentials: boolean;
        profileGuid: any;
        profileAvatarUrls?: {
          image128Url?: string | null;
          image256Url?: string | null;
          image512Url?: string | null;
        } | null;
        homeLocation: { label?: string | null };
        workHistories: Array<{ companyName: string; roleTitle: string }>;
        digitalIdentity?: { isVerified: boolean } | null;
      }
    | {
        __typename: 'UnrestrictedPublicProfileView';
        slug: string;
        firstName: string;
        lastName: string;
        hasVerifiedCredentials: boolean;
        personalSummary?: string | null;
        skills: Array<string>;
        languages: Array<string>;
        isOwnedByLoggedInUser: boolean;
        profileGuid: any;
        profileAvatarUrls?: {
          image128Url?: string | null;
          image256Url?: string | null;
          image512Url?: string | null;
        } | null;
        homeLocation: { label?: string | null };
        workHistories: Array<{
          companyName: string;
          roleTitle: string;
          achievements?: string | null;
          duration: { label?: string | null };
        }>;
        digitalIdentity?: {
          verifiedName?: string | null;
          isVerified: boolean;
        } | null;
        education: Array<
          | {
              __typename: 'UnverifiedPublicProfileEducation';
              name: string;
              institute: string;
              highlights?: string | null;
              completion: { label?: string | null };
            }
          | { __typename: 'VerifiedPublicProfileEducation'; name: string }
        >;
        licences: Array<
          | {
              __typename: 'UnverifiedPublicProfileLicence';
              name: string;
              description?: string | null;
              issuingOrganisation?: string | null;
            }
          | { __typename: 'VerifiedPublicProfileLicence'; name: string }
        >;
        rightsToWork: Array<{
          countryLabel: string;
          statusLabel: string;
          isVerified: boolean;
        }>;
      }
    | null;
};

export const PublicProfileViewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PublicProfileView' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'PublicProfileViewInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'locale' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Locale' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publicProfileView' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'UnrestrictedPublicProfileView',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileAvatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image128Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image256Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image512Url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'homeLocation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workHistories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'roleTitle' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'duration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'locale' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'locale',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'achievements' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasVerifiedCredentials' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'digitalIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'verifiedName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personalSummary' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'education' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UnverifiedPublicProfileEducation',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institute' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completion' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'label',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'locale',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'locale',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'highlights' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'VerifiedPublicProfileEducation',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'licences' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'UnverifiedPublicProfileLicence',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'issuingOrganisation',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'VerifiedPublicProfileLicence',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'skills' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'languages' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rightsToWork' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'countryLabel' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statusLabel' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isOwnedByLoggedInUser' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileGuid' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'RestrictedPublicProfileView',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileAvatarUrls' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image128Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image256Url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image512Url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'homeLocation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'label' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'locale' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'locale' },
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workHistories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'roleTitle' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasVerifiedCredentials' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'digitalIdentity' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isVerified' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileGuid' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __usePublicProfileViewQuery__
 *
 * To run a query within a React component, call `usePublicProfileViewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProfileViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProfileViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function usePublicProfileViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    PublicProfileViewQuery,
    PublicProfileViewQueryVariables
  > &
    (
      | { variables: PublicProfileViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PublicProfileViewQuery,
    PublicProfileViewQueryVariables
  >(PublicProfileViewDocument, options);
}
export function usePublicProfileViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PublicProfileViewQuery,
    PublicProfileViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PublicProfileViewQuery,
    PublicProfileViewQueryVariables
  >(PublicProfileViewDocument, options);
}
export function usePublicProfileViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PublicProfileViewQuery,
        PublicProfileViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PublicProfileViewQuery,
    PublicProfileViewQueryVariables
  >(PublicProfileViewDocument, options);
}
export type PublicProfileViewQueryHookResult = ReturnType<
  typeof usePublicProfileViewQuery
>;
export type PublicProfileViewLazyQueryHookResult = ReturnType<
  typeof usePublicProfileViewLazyQuery
>;
export type PublicProfileViewSuspenseQueryHookResult = ReturnType<
  typeof usePublicProfileViewSuspenseQuery
>;
export type PublicProfileViewQueryResult = Apollo.QueryResult<
  PublicProfileViewQuery,
  PublicProfileViewQueryVariables
>;
